import { ItemDetailsComponent } from './components/item-details/item-details.component';
import { DescriptionComponent } from './components/description/description.component';
import { AttributesComponent } from './components/attributes/attributes.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { PackagingComponent } from './components/packaging/packaging.component';
import { KitsComponent } from './components/kits/kits.component';
import { InterchangeComponent } from './components/interchange/interchange.component';
import { FitmentsComponent } from './components/fitments/fitments.component';
import { DigitalAssetsComponent } from './components/digital-assets/digital-assets.component';
import { CustomFieldsComponent } from './components/custom-fields/custom-fields.component';


export const segmentRoutes = [
  {
    path: '',
    component: ItemDetailsComponent,
  },
  {
    path: 'item-details',
    component: ItemDetailsComponent,
  },
  {
    path: 'description',
    component: DescriptionComponent,
  },
  {
    path: 'attributes',
    component: AttributesComponent,
  },
  {
    path: 'pricing',
    component: PricingComponent,
  },
  {
    path: 'packages',
    component: PackagingComponent,
  },
  {
    path: 'kits',
    component: KitsComponent,
  },
  {
    path: 'interchange',
    component: InterchangeComponent,
  },
  {
    path: 'fitments',
    component: FitmentsComponent,
  },
  {
    path: 'digital-assets',
    component: DigitalAssetsComponent,
  },
  {
    path: 'custom-fields',
    component: CustomFieldsComponent,
  }
];
